import { getFeatureFlagValue } from "@nju/feature-flags";
import { ConvergenceBanner } from "./ConvergenceBanner";
import { FtthBanner } from "./FtthBanner";
import { MobileBanner } from "./MobileBanner";
import { MultiDiscountBanner } from "./MultiDiscountBanner";
import { PostpaidBanner } from "./PostpaidBanner";

export function Starter() {
  const isPostpaidEnabled = getFeatureFlagValue("postpaid") === "1";

  return (
    <>
      <div className="flex flex-col gap-4 from-tablet:flex-row">
        {isPostpaidEnabled ? (
          <>
            <PostpaidBanner />
            <MobileBanner />
            <FtthBanner />
          </>
        ) : (
          <>
            <FtthBanner />
            <MobileBanner />
          </>
        )}
      </div>
      <div className="flex flex-col gap-4 from-tablet:flex-row">
        <ConvergenceBanner />
        <MultiDiscountBanner />
      </div>
    </>
  );
}
